import { Component, OnInit } from '@angular/core';
import { UpdateFormDataActionWithId } from '@app/finxone-web-frontend/app/lib/actions/form-submission.action';
import { FormActionTypeEnum } from '@finxone-platform/form-action';
import { Store } from '@ngxs/store';
import { map, takeUntil } from 'rxjs';
import { FormSubmitter } from '../../../form-widgets/form-submitter/form-submitter.component';

@Component({
  standalone: false,
  selector: 'finxone-web-frontend-edit-beneficiary-intl-beneficiary-address',
  templateUrl: './edit-beneficiary-intl-beneficiary-address.component.html',
  styleUrls: ['./edit-beneficiary-intl-beneficiary-address.component.scss'],
})
export class EditBeneficiaryIntlBeneficiaryAddressComponent extends FormSubmitter implements OnInit {
  public formStateData: Record<string, string>;
  public editAddress = true;

  constructor(public override store: Store) {
    super(store);
  }

  ngOnInit(): void {
    this.stateUpdatesListener();
  }

  private stateUpdatesListener(): void {
    this.getFormActionDataWithId(FormActionTypeEnum.INTL_BENEFICIARY_ADD)
      .pipe(
        takeUntil(this.destroy$),
        map((res: Record<string, any> | null) => {
          if (res?.['formData']) this.formStateData = res?.['formData'];
        }),
      )
      .subscribe();
  }

  public valueChange(formData: any) {
    this.store.dispatch(new UpdateFormDataActionWithId(formData, FormActionTypeEnum.INTL_BENEFICIARY_ADD));
  }
}
